import type { FaireProductEntity } from "../../entity_types/product";

export const p_5vabm4zrzc: FaireProductEntity = {
  token: "p_5vabm4zrzc",
  type: "product",
  name: "Small Baguette Hinged Huggie",
  brandToken: "b_7sddd34i",
  brandName: "Tai Jewelry",
  imageUrl:
    "https://cdn.faire.com/fastly/a128d84527ecc21be2e5f4252bea3eb01d323122f7d53c9b7b44aa34fa4ed3d4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e5aab5f832815a7a986bcec87bae11a0a2ef4e55d22891bd1bcfac1cf57f0749.jpeg",
    "https://cdn.faire.com/fastly/f72afdf05659356811071f7039cac08fb86748fb7d58aca0ac2e713209ea8d5b.jpeg",
    "https://cdn.faire.com/fastly/3222ad5db56b8eb79c2dbb413aa703eee397f84efa19c0e086a26ddb96d79ef0.jpeg",
    "https://cdn.faire.com/fastly/d2e29d3ff02022315bf6a8589ce03549c114cbca32355ad97adc048064f09180.jpeg",
    "https://cdn.faire.com/fastly/988f7ef83446f8923dd56384faacde40cc0f0670157a45bba16271ee75d1b410.jpeg",
    "https://cdn.faire.com/fastly/54d14559443c5429cd9b9bf393a26ec6addff62ee919791953477bc1a5cfe045.jpeg",
    "https://cdn.faire.com/fastly/8cda842c4072a0ab629a4ffc3e12cb1265b53fcc1bcb14ce3092121e3a62b09a.jpeg",
    "https://cdn.faire.com/fastly/993f79860accba8732173e9d799d33e61032f523e106b9dfc15fbe65a6871c8b.jpeg",
    "https://cdn.faire.com/fastly/a38221150ffbfc6e57b29d9fa061a1681079861a012636b1130052a3a7685b63.jpeg",
  ],
  priceDollars: 41.57,
  description:
    "Add a vibrant twist to your look with these Color Pop Baguette Huggies. Featuring stacked baguette CZ stones in playful hues, these huggies are your go-to for instant glam. Whether you're dressing up or keeping it casual, these earrings bring bold energy to any outfit.\n\nMaterial: Gold-plated brass, Cubic Zirconia \nSKU: TE-2292",
  tags: [],
  msrpDollars: 83.14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:38.442Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
